"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFileUploadRequest = exports.mapNewFileUploadsResponse = exports.mapFileUploadResponse = void 0;
const mapFileUploadResponse = (f) => ({
    id: f.id,
    filename: f.filename,
    contentType: f.content_type,
    contentLength: f.content_length,
    url: f.url,
    createdAt: f.created_at,
    completedSteps: f.completed_steps.map((step) => ({
        stepName: step.step_name,
        error: step.error,
        createdAt: step.created_at,
    })),
});
exports.mapFileUploadResponse = mapFileUploadResponse;
const mapNewFileUploadsResponse = (fileUploads) => {
    return fileUploads.map(({ fields, path }) => ({
        fileUploadId: fields['x-amz-meta-upload-id'],
        uploadUrl: fields.presigned_url,
        path,
    }));
};
exports.mapNewFileUploadsResponse = mapNewFileUploadsResponse;
const mapFileUploadRequest = (fileUpload) => ({
    'content-length': fileUpload.contentLength,
    'content-type': fileUpload.contentType,
    id: fileUpload.id,
    filename: fileUpload.filename,
    url: fileUpload.url,
});
exports.mapFileUploadRequest = mapFileUploadRequest;
